import { render, staticRenderFns } from "./FeaturedTVShows.vue?vue&type=template&id=414dadf4&scoped=true&"
import script from "./FeaturedTVShows.vue?vue&type=script&lang=js&"
export * from "./FeaturedTVShows.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedTVShows.vue?vue&type=style&index=0&id=414dadf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414dadf4",
  null
  
)

component.options.__file = "FeaturedTVShows.vue"
export default component.exports